import { get, isNumber } from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import StatusWithDraft from '../../../../model/StatusWithDraft';
import gql from '../../../../modules/Organization/OrganisationGroups/OrganisationHolidayCalendars/data/organisationHolidayCalendars.graphql';
import getGqlOperationName from '../../../utils/getGqlOperationName';
import useT from '../../utils/Translations/useT';

import MultiselectFilter from './MultiselectFilter';

const OrgHolidayCalendarsSelector = ({
  organisationGroupId,
  organisationIds,
  ...rest
}) => {
  const t = useT();

  const queryRes = useQuery(gql, {
    variables: {
      organisationGroupId,
      organisationIds,
      calendarStatus: StatusWithDraft.Active.value,
    },
    skip: !isNumber(organisationGroupId),
  });

  const options = useMemo(
    () => get(queryRes, `data.${getGqlOperationName(gql)}`, []),
    [queryRes],
  );

  const title = useMemo(
    () => (queryRes.loading ? 'Loading Calendars...' : 'Calendars'),
    [queryRes.loading],
  );

  return (
    <MultiselectFilter
      disabled={queryRes.loading}
      options={options}
      title={t(title)}
      {...rest}
    />
  );
};

OrgHolidayCalendarsSelector.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.arrayOf(PropTypes.string),
  ]),
  onChange: PropTypes.func,
  organisationGroupId: PropTypes.number,
  organisationIds: PropTypes.arrayOf(
    PropTypes.shape({
      organisationId: PropTypes.number.isRequired,
      orgStructLevelId: PropTypes.number.isRequired,
    }),
  ),
};

OrgHolidayCalendarsSelector.defaultProps = {
  value: [],
  onChange: null,
  organisationGroupId: null,
  organisationIds: [],
};

export default OrgHolidayCalendarsSelector;
